import React from 'react'; 
import { observer } from 'mobx-react'; 
import BermSlope from 'cd-eft/assets/images/BermSlope.png'; 

export const BermImage = () => {
    return(
        <div tabIndex={0}>
            <img src={BermSlope} width= {'100%'} alt="A Diagram of a Berm"/>
        </div>
    ); 
}; 

export const WaterWayBermDetails = observer(BermImage); 